import {
  LOAD_VELOCITYSUMMARY,
  LOAD_VEHICLE_VELOCITYSUMMARY,
  LOAD_VEHICLE_TYPE_VELOCITYSUMMARY
} from "./actions";

const initialState = {
  velocitysummaryUrl: "",
  vehicleLists: [],
  vehicleTypeLists: [],
  velocitysummaryLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_VELOCITYSUMMARY.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        velocitysummaryLoading: loading
      };
    case LOAD_VELOCITYSUMMARY.SUCCESS:

      return {
        ...state,
        velocitysummaryUrl: action.payload.data.data,
        velocitysummaryLoading: false
      };
    case LOAD_VEHICLE_VELOCITYSUMMARY.REQUEST:
      const { loading_vehicle } = action.payload;
      return {
        ...state,
        velocitysummaryLoading: loading_vehicle
      };
    case LOAD_VEHICLE_VELOCITYSUMMARY.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        velocitysummaryLoading: false
      };
    case LOAD_VEHICLE_TYPE_VELOCITYSUMMARY.SUCCESS:
      return {
        ...state,
        vehicleTypeLists: action.payload.data.data
      };
    default:
      return state;
  }
};
